export const ROLES = {
  MASTER: "masterAdmin",
  TEACHER: "teacher",
  STUDENT: "student"
};

export const STATUSES = {
  PENDING: "pending",
  PENDING_APPROVAL: "pending",  // Alias for clarity
  ACTIVE: "active",
  DISABLED: "disabled"
  // ✅ REMOVED: "pending_card_verification" - no longer used
};

export const APPROVED_ROLES = new Set([ROLES.MASTER, ROLES.TEACHER, ROLES.STUDENT]);

export const PLANS = {
  TRIAL: "trial",
  TRIAL_VERIFIED: "trial_verified",  // ✅ Deprecated (backward compat only)
  MONTHLY: "monthly",
  YEARLY: "yearly",
  FREE: "free"
};

export const PLAN_STATUS = {
  TRIAL: "trial",
  ACTIVE: "active",
  SUSPENDED: "suspended",
};